import clsx from 'clsx';
import type { HTMLAttributes, ReactNode } from 'react';

export interface CardProps extends HTMLAttributes<HTMLElement> {
  readonly as?: 'article' | 'div' | 'section';
  readonly lifted?: boolean;
  readonly tone?: 'default' | 'evidence' | 'objection' | 'claim' | 'source';
  /** Escolhido noutro sitio da pagina — na timeline, por exemplo. */
  readonly selected?: boolean;
}

export function Card({
  as: Tag = 'article', lifted, tone = 'default', selected, className, children, ...rest
}: CardProps) {
  return (
    <Tag
      className={clsx('et-card', lifted && 'et-card--lifted', tone !== 'default' && `et-card--${tone}`, selected && 'et-card--selected', className)}
      {...(selected === true ? { 'aria-current': 'true' as const } : {})}
      {...rest}
    >
      {children}
    </Tag>
  );
}

export const CardBody = ({ className, children }: { className?: string; children: ReactNode }) => (
  <div className={clsx('et-card__body', className)}>{children}</div>
);

export const CardSection = ({ title, children }: { title?: string; children: ReactNode }) => (
  <div className="et-card__section">
    {title && <h4 className="et-card__section-title">{title}</h4>}
    {children}
  </div>
);

export const CardFooter = ({ children }: { children: ReactNode }) => (
  <div className="et-card__footer">{children}</div>
);

/**
 * §8 — o par. `DoesProve` diz o alcance, `DoesNotProve` diz onde ele acaba, e
 * os dois tem tratamento visual proprio porque sao as duas partes que a
 * apologetica e o cepticismo omitem, cada um a sua. Nao sao paragrafos
 * quaisquer, e nao aparecem um sem o outro.
 */
export const DoesProve = ({ children }: { children: ReactNode }) => (
  <div className="et-pos">{children}</div>
);

export const DoesNotProve = ({ children }: { children: ReactNode }) => (
  <div className="et-neg">{children}</div>
);
